export const commercialSourceV107 = (log, zh) =>
  log.source_name ||
  log.source_id ||
  (log.billing_mode === 'openlux_deferred'
    ? zh
      ? '待确认'
      : 'Pending confirmation'
    : log.source_kind
    ? zh
      ? '未公开 Source'
      : 'Undisclosed source'
    : '-');

export const commercialMultiplierV107 = (log, zh = true) => {
  const value = Object.prototype.hasOwnProperty.call(log, 'source_multiplier')
    ? log.source_multiplier
    : log.effective_multiplier;
  return typeof value === 'string' && /^\d+(\.\d+)?$/.test(value)
    ? `x${value.replace(/(\.\d*?)0+$/, '$1').replace(/\.$/, '')}`
    : log.billing_mode === 'openlux_deferred'
    ? zh
      ? '待确认'
      : 'Pending confirmation'
    : '-';
};

export const commercialReceiptStateV107 = (log, zh) => {
  if (
    !['openlux_receipt', 'openlux_deferred', 'base_source_receipt'].includes(
      log.billing_mode
    )
  )
    return '';
  const labels = {
    pending_receipt: ['待回查', 'Awaiting receipt'],
    fallback_charged: ['中位倍率兜底结算', 'Settled using median multiplier'],
    needs_review: ['回执需核查', 'Receipt needs review'],
    no_charge: ['未扣费', 'No charge'],
    unavailable: ['结算暂不可用', 'Settlement unavailable'],
  };
  if (
    log.billing_mode === 'openlux_deferred' &&
    log.billing_status === 'pending_receipt'
  ) {
    return zh ? '待确认 · 未扣费' : 'Pending confirmation · not charged';
  }
  const state = labels[log.billing_status];
  if (state) return state[zh ? 0 : 1];
  if (log.billing_status === 'charged') {
    return log.price_is_estimate
      ? zh
        ? '已结算 · 月度折扣暂估'
        : 'Settled · monthly discount estimated'
      : zh
      ? '已结算'
      : 'Settled';
  }
  return zh ? '结算状态未知' : 'Settlement unknown';
};
